<template>
  <div :class="ns">
    <div v-if="title || slots?.title" :class="[_ns.e('title')]">
      <span v-if="!slots?.title">{{ title }}</span>
      <slot v-else name="title" />
    </div>
    <slot />
  </div>
</template>
<script lang="ts" setup>
import { computed, useSlots } from 'vue'
import { useNamespace } from '@xzx-design/hooks'
import { panelProps } from './panel'

defineOptions({
  name: 'XzxPanel',
})

const props = defineProps(panelProps)

const slots = useSlots()

const _ns = useNamespace('panel')

const ns = computed(() => [
  _ns.b(),
  props.br && _ns.m('lg-br'),
  props.margin && _ns.m('margin'),
])
// init here
</script>
